import React from 'react';
import { Icon } from '@iconify/react';

const FormButton = ({
    type = 'button',
    onClick,
    className = '',
    disabled = false,
    children,
    icon,
    variant = 'primary', // primary, secondary, outline-secondary, etc.
    isLoading = false
}) => {
    // Base classes
    let btnClass = `btn px-20 py-10 radius-8 ${className} `;

    // Variant classes
    if (variant === 'primary') {
        btnClass += 'text-white ';
        // If background color needs to be specific orange/yellow as in ChargeHead
        if (!className.includes('bg-')) {
             // For buttons that were typically using style={{ backgroundColor: '#f59e0b' }}
             // We can either rely on utility classes or pass a style prop.
             // Assuming we want to stick to standard bootstap/theme classes where possible,
             // but 'btn-primary' might be blue.
             // If the project uses 'btn-warning' or custom color, we should adapt.
             // For now, let's allow style prop in implementation if needed, or use a default class.
        }
    } else if (variant === 'outline-secondary') {
        btnClass += 'btn-outline-secondary ';
    }

    return (
        <button
            type={type}
            onClick={onClick}
            className={btnClass}
            disabled={disabled || isLoading}
            style={variant === 'primary' ? { backgroundColor: '#f59e0b', borderColor: '#f59e0b', color:'white' } : {}}
        >
            {isLoading ? (
                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
            ) : (
                icon && <Icon icon={icon} className="text-lg me-1" />
            )}
            {children}
        </button>
    );
};

export default FormButton;
